@if (enhancedExchanges.length > 0) {
  @if (showHeader()) {
    <sidebar-header
      [title]="title"
      [indicator]="showIndicator ? enhancedExchanges.length : 0"
      class="block border-0 border-b-2 border-solid border-default"
    />
  }
  @for (exchange of enhancedExchanges; track $index) {
    <div sidebarRequestItem>
      <div
        role="button"
        tabindex="0"
        class="cursor-pointer"
        [ngClass]="{ 'flex items-start gap-3': showAvatars }"
        (click)="showRequest(exchange)"
        (keydown.enter)="showRequest(exchange)"
        (keydown.space)="$event.preventDefault(); showRequest(exchange)"
      >
        @if (showAvatars) {
          <sb-avatar-badge-group
            class="shrink-0"
            [employees]="exchange.relevantEmployees"
            [truncateEmployeesAfter]="exchange.relevantEmployees.length > 2 ? 1 : 0"
          />
        }
        <sb-summary-item [compact]="true">
          <span firstRowLeft class="truncate">
            {{ exchange.Schedule?.location_name }}
            - {{ exchange.Schedule?.department_name }}
          </span>
          <span secondRowLeft>
            {{ exchange.date | localeDate: 'compact' }}: {{ exchange.Schedule?.starttime | time }}
            @if (!exchange.Schedule?.hide_end_time) {
              - {{ exchange.Schedule?.endtime | time }}
            }
          </span>
        </sb-summary-item>
      </div>
    </div>
  }
}
